import { useRef } from "react";
import { SWReactIcons } from "@similarweb/icons";
import { BooleanSearchInput, BooleanSearchInputWrap } from "@similarweb/ui-components";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { ButtonsContainer } from "app/components/React/TrafficAndEngagementGrowth/styledComponents";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { SearchContainer } from "../styles";
import { allTrackers } from "app/services/track/track";
import { KEYS } from "app/pages/website-analysis/website-technologies/constants/constants";
import type { SearchTechnologyProps } from "../types";
import { swSettings } from "app/common/services/swSettings";
import { getExcelButtonText } from "app/components/React/ExcelButton/getExcelButtonText";

export function SearchTechnology({ onSearch, value, isDisabled, excelUrl }: SearchTechnologyProps) {
    const ref = useRef<HTMLInputElement>(null);
    const translate = useTranslation();

    const excelLocked = !swSettings.current.resources.IsExcelAllowed;
    const trackExcel = () => allTrackers.dispatchTrackEvent("Download", "click", "Table/Excel");
    const onClick = () => ref.current.focus();

    return (
        <SearchContainer onClick={onClick}>
            <SWReactIcons
                size="sm"
                iconName="search"
            />
            <BooleanSearchInputWrap>
                <BooleanSearchInput
                    ref={ref}
                    value={value}
                    disabled={isDisabled}
                    onChange={onSearch}
                    placeholder={translate(KEYS.searchPlaceholder)}
                />
            </BooleanSearchInputWrap>
            <ButtonsContainer>
                <DownloadButtonMenu
                    Excel
                    isDisabled={isDisabled}
                    iconNameProps={excelLocked ? "excel-download" : null}
                    downloadUrl={excelUrl}
                    exportFunction={trackExcel}
                    excelLocked={excelLocked}
                    downloadTooltipConfig={{
                        enabled: !isDisabled,
                    }}
                    buttonText={getExcelButtonText()}
                />
            </ButtonsContainer>
        </SearchContainer>
    );
}
